import React, { useEffect } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import { getModuleServiceList } from '../../../services/clientInvoice';
import { noop } from 'lodash';

export type ServiceSelectProps = SelectProps<any> & {
  module: string;
};

const ServiceSelect = (props: ServiceSelectProps) => {
  const { module, onChange = noop, ...rest } = props;

  const { data: services } = useQuery(
    ['getModuleServiceList', { module }],
    () => getModuleServiceList({ module }).then((res) => res.list || []),
    { staleTime: MINUTE }
  );

  useEffect(() => {
    if (services && services.length > 0) {
      onChange(services[0].funcode);
    }
  }, [services]);

  return (
    <Select {...rest} onChange={onChange}>
      {services?.map(({ funcode, funlabel }, i) => (
        <Select.Option value={funcode} key={i}>
          {funlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ServiceSelect;
